import { de_SendPOAEMailCommand, se_SendPOAEMailCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class SendPOAEMailCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Api", "SendPOAEMail", {})
    .n("ApiClient", "SendPOAEMailCommand")
    .f(void 0, void 0)
    .ser(se_SendPOAEMailCommand)
    .de(de_SendPOAEMailCommand)
    .build() {
}
